/** The gray "Made by" line on a task card (Tasks Both Ways slice 5). */
import { cn } from "@/lib/utils";
import { MADE_BY_ICON, madeByLine, type MadeBy } from "@/lib/task-made-by";
import { ClipboardList } from "lucide-react";

export function MadeByLine({ madeBy, className }: { madeBy: MadeBy | null | undefined; className?: string }) {
    if (!madeBy) return null;
    const Icon = MADE_BY_ICON[madeBy.icon] ?? ClipboardList;
    return (
        <p
            className={cn("flex items-center gap-1.5 text-xs font-medium text-muted-foreground", className)}
            data-testid="made-by"
        >
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{madeByLine(madeBy)}</span>
        </p>
    );
}
